export default function Footer() {
  return (
    <footer className="bg-background-200/70 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="font-heading font-semibold text-foreground-900 mb-3 text-base">
              Sugargoo Spreadsheet
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Your trusted resource for organized Sugargoo product finds, shopping guides, shipping information, and expert reviews.
            </p>
          </div>
          <div>
            <h3 className="font-heading font-semibold text-foreground-900 mb-3 text-base">
              Quick Links
            </h3>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="hover:text-primary-500 transition-colors duration-200">Main Website</a></li>
              <li><a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="hover:text-primary-500 transition-colors duration-200">Shoes Category</a></li>
              <li><a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="hover:text-primary-500 transition-colors duration-200">T-Shirts Collection</a></li>
            </ul>
          </div>
          <div>
            <h3 className="font-heading font-semibold text-foreground-900 mb-3 text-base">
              Resources
            </h3>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="hover:text-primary-500 transition-colors duration-200">Sugargoo Spreadsheet</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="hover:text-primary-500 transition-colors duration-200">Buy It Now</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-background-200/60 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} sugargoosheet.homes — All rights reserved. This website provides educational resources only.
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <span className="w-3 h-3 flex items-center justify-center"><i className="ri-lock-line"></i></span>
              HTTPS Secured
            </span>
            <span className="flex items-center gap-1">
              <span className="w-3 h-3 flex items-center justify-center"><i className="ri-shield-line"></i></span>
              Privacy Respected
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}